// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"bb4e8ca99a77b00026d8","731":"acea3820ae59e6962074","843":"00fc85212cf7334645bd","883":"08ff4a1df1812b05e366"}[chunkId] + ".js";
};